<template>
  <div id="departments">
    <!-- <div style="height: 6px;"></div>
    <div style="padding: 6px;">
      <span style="font-size:16px;padding-left: 14px;">
        <i style="display: inline-block; width: 18px;height: 18px;position: relative;top: 3px;">
          <img style="width: 100%;height: 100%;" src="@/assets/tag.png" alt="">
        </i>
        {{$t('message.title.manufacturer')}}
      </span>
    </div> -->

    <!-- <div style="margin-top: 10px;margin-right: 20px;">
      <div class="edit-table" style="float: right;overflow: hidden;height: 33px;">
      </div>
    </div> -->

    <div>
      <vxe-grid
        ref="xGrid"
        v-bind="gridOptions"
        :loading="MFTloading"
        @edit-disabled="editDisabledEvent"
        @cell-dblclick="noEdit"
        @scroll="handleScroll"
        @checkbox-change="checkboxChangeEvent"
        @checkbox-all="checkboxChangeEvent"
      >
        <template #toolbar_buttons>
          <el-button
            class="btn btn1"
            icon="el-icon-circle-plus-outline"
            @click="searchAddBom = true"
            :disabled="!editTable || !addTableListPriv"
            >{{ $t("message.button.add") }}
          </el-button>
          <el-button
            class="btn btn2"
            icon="el-icon-delete"
            @click="removeCheckbox"
            :disabled="!editTable || !removeBtnPriv"
            >{{ $t("message.button.delete") }}
          </el-button>
          <el-button
            class="btn btn7"
            icon="el-icon-document-checked"
            @click="getUpdateEvent"
            v-if="!editShow"
            :disabled="!editTable || !addTableListPriv"
            >{{ $t("message.button.save") }}
          </el-button>
          <el-button
            class="btn btn8"
            icon="el-icon-circle-close"
            @click="closeSave"
            v-if="!editShow"
            :disabled="!editTable || !addTableListPriv"
            >{{ $t("message.button.cancel") }}
          </el-button>
        </template>
        <template #bottom>
          <Bottom-Tips
            :data="{ selectRecords: selectRecords.length, totalRecords }"
          />
        </template>
      </vxe-grid>
    </div>

    <el-dialog
      v-if="searchAddBom"
      class="searchAddBomList"
      :title="$t('message.title.add')"
      :visible.sync="searchAddBom"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <searchAdd @listDbClick="addList">
        <div>
          <el-button
            size="small"
            type="primary"
            icon="el-icon-edit-outline"
            @click="creatNew = true"
            >{{ $t("message.button.create") }}</el-button
          >
        </div>
      </searchAdd>
    </el-dialog>

    <el-dialog
      v-if="creatNew"
      class="searchAddBomList"
      :title="$t('message.title.add')"
      :visible.sync="creatNew"
      :close-on-click-modal="!creatNew"
    >
      <!-- <searchAdd @listDbClick="addList"></searchAdd> -->
      <Create
        :classId_="createClassId"
        :saveUrl="saveTableUrl"
        :baseClass="baseClass_"
        @addToList="creatNewManu"
        @closeCreateNew="closeCreateNew"
      ></Create>
    </el-dialog>

    <el-dialog
      v-if="cascaderShow"
      class="searchAddBomList"
      :title="$t('message.title.add')"
      :visible.sync="cascaderShow"
      @close="closeCascaderShow"
    >
      <div style="height: 270px">
        <div style="margin: 60px auto; padding-left: 50px">
          <el-cascader
            v-model="cascaderValue"
            :options="cascaderList"
            :props="cascaderProps"
            :show-all-levels="true"
            size="small"
            ref="cascaderAddr"
            style="width: 75%"
          ></el-cascader>
          <el-button
            size="small"
            type="primary"
            style="margin-left: 10px"
            @click="getCascadeValue"
            >{{ $t("message.button.affirm") }}</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
//;
import searchAdd from "@/components/searchManufacturers.vue";
import Create from "@/components/common/Create.vue";
import axios from "axios";

export default {
  name: "BOM",
  data() {
    return {
      dataLink: "",
      createClassId: "10601",
      baseClass_: "106",
      saveTableUrl: "/pmdm/manufacturerPart/saveManufacturerPartP1P2P3",
      creatNew: false,

      searchAddBom: false, //添加窗口开关
      oldTableValue: {},
      version: "",
      editTable: false,

      pageIndex: 2,
      dataComplete: false,
      finished: true,
      selectRecords: [],
      totalRecords: "",
      gridOptions: {
        toolbarConfig: {
          zoom: true,
          custom: true,
          slots: {
            buttons: "toolbar_buttons",
          },
        },
        keepSource: true,
        resizable: true,
        border: true,
        stripe: true,
        highlightHoverRow: true,
        highlightCurrentRow: true,
        showHeaderOverflow: true,
        showOverflow: true,
        rowId: "id",
        height: "560",
        size: "small",
        columns: [
          {
            type: "checkbox",
            width: 50,
            fixed: null,
          },
        ],
        data: [],
        treeConfig: {
          lazy: true,
          children: "children",
          hasChild: "hasChildren",
          loadMethod: this.loadChildrenMethod,
        },
        editConfig: {
          trigger: "dblclick",
          mode: "row",
          showIcon: false,
          activeMethod: this.activeRowMethod,
          showStatus: true,
        },
        sortConfig: {
          trigger: "cell",
        },
      },
      editShow: false,
      leftShow: true,
      showBtn: false,

      loading: true,
      MFTloading: false,
      cols: [], //表头
      rols: [], //表体所有内容
      rols_text: [], //表体显示内容
      tableShow: false, //显示table
      get_change_info: "", //父组件传来的值
      select_list: {},
      childsTable: [], //子列表集合
      childsIndex: [], //子列表index集合

      removeBtnPriv: false,
      addTableListPriv: false,

      cascaderShow: false,
      cascaderValue: [],
      cascaderList: [],
      cascaderProps: {},
    };
  },
  mounted() {},
  components: {
    searchAdd,
    Create,
  },
  methods: {
    handleScroll(e) {
      if (e.isX == true) return false;
      var rl = this.$refs.xGrid.$el.querySelector(".vxe-table--body-wrapper");
      // if(e.scrollTop == rl.scrollHeight - rl.clientHeight) { //判断是否到底
      //   if (e.isY && !this.dataComplete) {
      // console.log(this.finished);
      // console.log(this.dataComplete);
      if (
        this.finished &&
        !this.dataComplete &&
        e.scrollTop + 200 > rl.scrollHeight - rl.clientHeight
      ) {
        //判断是否到底
        this.finished = false;
        this.onScroll(e);
      }
    },
    onScroll(e) {
      var vm = this;
      let change_info = this.$store.state.change_info;
      if (this.get_change_info == "") {
        change_info = this.$store.state.change_info;
      } else {
        change_info = this.get_change_info;
      }
      this.MFTloading = true;
      let obj_get = {
        //获取change
        ...this.$store.state.objectId,
        //id: this.$store.state.objId_,
        //classId: this.$store.state.classId_,
        //subClassId: this.$store.state.subClassId_,
        changeId: change_info.changeId,
        changeClassId: change_info.changeClassId,
        changeSubClassId: change_info.changeSubClassId,
        tableId: 16,
        page: this.pageIndex,
        size: 40,
      };
      // console.log(obj_get);
      let loadTableUrl = `/pmdm/items/loadTable${this.params(obj_get)}`;
      axios.get(loadTableUrl).then((res) => {
        let m = this.getNewTableContentData(res.data);
        const n = this.getNewTableContentData(res.data);
        // console.log(m,n);

        this.oldTableValue = this.oldTableValue.concat(n);
        this.pageIndex++;
        this.scroll_top += 2;

        this.MFTloading = false;
        var total_record = this.pageIndex - 1;

        this.totalRecords = res.data.object.table.totalRecords;

        let rolArr = res.data.object.table.rows;
        console.log(rolArr);
        for (let i = 0; i < rolArr.length; i++) {
          const e = rolArr[i];

          Object.assign(m[i], { link: e.cells });
        }

        this.gridOptions.data = this.gridOptions.data.concat(m);

        if (total_record * 40 > res.data.object.table.totalRecords) {
          vm.$message({
            message: this.$t("message.tips.dataEnd"),
            type: "warning",
          });
          this.dataComplete = true;
        }
        this.finished = true;
      });
    },
    checkboxChangeEvent({ records }) {
      const $grid = this.$refs.xGrid;
      this.selectRecords = records;
    },
    closeCreateNew() {
      this.creatNew = false;
    },
    creatNewManu(e) {
      this.creatNew = false;
      this.searchAddBom = false;
      this.addList(e);
    },
    noEdit({ row, columnIndex }) {
      if (column.editRender.cascaderType && this.editTable) {
        this.cascaderList = column.editRender.cascadeOptions;
        let m = row[[column.property]];
        if (column.editRender.props.multiple) {
          this.cascaderValue = m
            ? m.map((i) => {
                return this.getParentIdList(this.cascaderList, i);
              })
            : "";
          this.cascaderProps.multiple = true;
        } else {
          this.cascaderProps.multiple = false;
          this.cascaderValue = m;
        }
        this.cascaderProps.checkStrictly = true;
        this.tempData = { row, column };
        this.cascaderShow = true;
        console.log(this.cascaderValue);
      }
    },
    removeCheckbox() {
      //删除
      var change_info = this.$store.state.change_info;
      //var removeRow = this.$refs.xGrid.removeCheckboxRow();
      var removeRow = this.$refs.xGrid.getCheckboxRecords();

      var del_table = [];
      var vm = this;
      if (removeRow.length == 0) {
        return false;
      } else {
        console.log(removeRow);
        for (var i = 0; i < removeRow.length; i++) {
          var obj = {};
          obj.id = removeRow[i].rowId;
          obj.manufacturerPartId = removeRow[i].itemId;
          del_table.push(obj);
        }
        var delBomData = {
          tableId: 16,
          changeObjId: {
            id: change_info.changeId,
            classId: change_info.changeClassId,
            subClassId: change_info.changeSubClassId,
          },
          itemObjId: {
            ...this.$store.state.objectId,
            //id: this.$store.state.objId_,
            //classId: this.$store.state.classId_,
            //subClassId: this.$store.state.subClassId_,
            version: this.version,
          },
          deleteManufacturer: del_table,
        };
        console.log(delBomData);
        axios
          .post("/pmdm/items/deleteTable", delBomData)
          .then(function (res) {
            if (res.data.code == 200) {
              vm.$message({
                message: res.data.message,
                type: "success",
              });
              console.log(res);
              vm.selectRecords = [];
              vm.getBomInfo();
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    addList(row) {
      //添加
      console.log(row);

      const arr = this.rols_text.map((i) => i.itemId);
      for (var i = 0; i < row.length; i++) {
        if (arr.indexOf(row[i].id) != -1) {
          this.$message.error(this.$t("message.error.same"));
          return false;
        }
      }

      // this.searchAddBom = false;
      console.log(row);
      var change_info = this.$store.state.change_info;

      // for(var j = 0; j < row.length; j++) {

      // }
      let insertBom = row.map((i) => {
        return {
          manufacturerPartId: i.id,
          manufacturerId: i.manufacturerId,
          itemId: this.$store.state.objectId.id,
        };
      });

      var updateBomData = {
        //post更改的值
        tableId: 16,
        changeObjId: {
          id: change_info.changeId,
          classId: change_info.changeClassId,
          subClassId: change_info.changeSubClassId,
        },
        itemObjId: {
          ...this.$store.state.objectId,
          //id: this.$store.state.objId_,
          //classId: this.$store.state.classId_,
          //subClassId: this.$store.state.subClassId_,
          version: this.version,
        },
        insertManufacturer: insertBom,
      };
      var vm = this;
      axios
        .post("/pmdm/items/saveTable", updateBomData)
        .then(function (res) {
          if (res.data.code == 200) {
            vm.$message({
              message: res.data.message,
              type: "success",
            });
            vm.getBomInfo();
            if (vm.dataComplete) {
              (vm.pageIndex = vm.pageIndex - 1), (vm.dataComplete = false);
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    handleClose(done) {
      this.$confirm(this.$t("message.confirm.close"))
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    closeSave() {
      this.$refs.xGrid.revertData(); //清除所有保存，删除，添加记录
    },
    getDataCheck() {
      const systemCode = window.sessionStorage.getItem("systemCode") || "";
      if (!systemCode.toLowerCase() === "jurong") {
        return false;
      }
      const index = this.gridOptions.columns.find(
        (i) => i.attid === 1016021
      ).field;

      const list = this.gridOptions.data.map((i) => {
        const val = i[index];
        return val;
      });

      const arr = [...new Set(list)];
      if (arr.length < list.length) {
        return true;
      }
      return false;
    },
    getUpdateEvent() {
      var vm = this;
      var xGrid_ = this.$refs.xGrid;
      let updateRecords = this.$refs.xGrid.getUpdateRecords(); //获取修改的行

      const hasCheck = this.getDataCheck();
      if (hasCheck) {
        //首选状态替代项不可重复
        this.$message.error(this.$t("message.tips.item_mfc_tips"));
        return;
      }

      var updateBom = [];
      if (updateRecords.length !== 0) {
        //判断行内那些值有改动
        for (let i = 0; i < updateRecords.length; i++) {
          var num = xGrid_.getRowIndex(updateRecords[i]);
          var cols_length = this.cols;
          for (let j = 0; j < cols_length.length; j++) {
            var updateNewData = xGrid_.isUpdateByRow(updateRecords[i], "" + j);
            if (updateNewData) {
              // var obj = {};
              // var quantity = cols_length[j];
              // obj.id = updateRecords[i].rowId;
              // obj[quantity] = updateRecords[i][j];
              // updateBom.push(obj);
              for (let k = 0; k < this.gridOptions.columns.length; k++) {
                var obj = {};
                if (cols_length[j] == this.gridOptions.columns[k].attid) {
                  var quantity = cols_length[j];
                  obj.id = updateRecords[i].rowId;
                  if (this.gridOptions.columns[k].editRender.props) {
                    //处理多选和单选
                    if (this.gridOptions.columns[k].editRender.props.multiple) {
                      obj[quantity] = updateRecords[i][j].join(";");
                    } else {
                      if (updateRecords[i][j] == null) {
                        obj[quantity] = "";
                      } else {
                        obj[quantity] = updateRecords[i][j];
                      }
                    }
                  } else {
                    if (updateRecords[i][j] == null) {
                      obj[quantity] = "";
                    } else {
                      obj[quantity] = updateRecords[i][j];
                    }
                  }
                  updateBom.push(obj);
                }
              }
            }
          }
        }
        var change_info = this.$store.state.change_info;
        var updateBomData = {
          //post更改的值
          tableId: 16,
          changeObjId: {
            id: change_info.changeId,
            classId: change_info.changeClassId,
            subClassId: change_info.changeSubClassId,
          },
          itemObjId: {
            ...this.$store.state.objectId,
            //id: this.$store.state.objId_,
            //classId: this.$store.state.classId_,
            //subClassId: this.$store.state.subClassId_,
            version: this.version,
          },
          updateManufacturer: this.arrayFilter(updateBom),
        };
        axios
          .post("/pmdm/items/updateTable", updateBomData)
          .then(function (res) {
            console.log(res);
            if (res.data.code == 200) {
              vm.$message({
                message: res.data.message,
                type: "success",
              });
              vm.getBomInfo();
              xGrid_.revertData();
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      }
      // console.log(this.oldTableValue);
      //this.clearAll();
      //this.editShow = true;
      //this.showBtn = true;
    },
    activeRowMethod({ row, rowIndex }) {
      if (this.editTable == false) {
        return false;
      }
      if (this.childsTable.length !== 0) {
        for (var i = 0; i < this.childsTable.length; i++) {
          if (row[0] == this.childsTable[i][0]) {
            return false;
          }
        }
      }
      return true;
    },
    editDisabledEvent({ row, column }) {
      this.$message.error(this.$t("message.error.noEdit"));
    },
    toLink(e, c) {
      const n = parseInt(c.property);
      const { id, classId, subclassId, val: title } = e.link[n];
      this.getLink({ id, classId, subclassId, title });
    },
    async getBomInfo() {
      this.$emit("refreshTab");
      this.MFTloading = true;

      var change_info = this.$store.state.change_info;
      if (this.get_change_info == "") {
        change_info = this.$store.state.change_info;
      } else {
        change_info = this.get_change_info;
      }

      let BOMChangeInfo = this.$store.state.setBOMChangeInfo;

      var obj_get = {
        //获取change
        ...this.$store.state.objectId,
        //id: this.$store.state.objId_,
        //classId: this.$store.state.classId_,
        //subClassId: this.$store.state.subClassId_,
        changeId: change_info.changeId,
        changeClassId: change_info.changeClassId,
        changeSubClassId: change_info.changeSubClassId,
        tableId: 16,
        page: 1,
        size: 40,
      };

      var loadTableUrl = `/pmdm/items/loadTable${this.params(obj_get)}`;

      const { data: res } = await this.$http.get(loadTableUrl);
      this.MFTloading = false;
      this.gridOptions.columns = this.getNewTableTitleData(res);
      // console.log(this.gridOptions.columns);
      this.manuName = this.gridOptions.columns[1].title;
      // console.log(this.gridOptions.columns);
      this.cols = res.object.table.columnInfo.ids;

      this.rols_text = this.getNewTableContentData(res);
      let rolArr = res.object.table.rows;
      for (let i = 0; i < rolArr.length; i++) {
        const e = rolArr[i];
        // console.log(e);
        Object.assign(this.rols_text[i], { link: e.cells });
      }
      console.log(this.rols_text);

      const tableContent = this.getNewTableContentData(res);

      this.gridOptions.data = this.rols_text;
      // this.$refs.xGrid.loadData(this.rols_text);
      this.totalRecords = res.object.table.totalRecords;
      // console.log(this.totalRecords);

      this.tableShow = true;

      this.oldTableValue = tableContent;
      this.version = res.object.table.version;
    },
    async loadChildrenMethod({ row }) {
      //获取子节点
      // 异步加载子节点

      var change_info = this.$store.state.change_info;
      if (this.get_change_info == "") {
        change_info = this.$store.state.change_info;
      } else {
        change_info = this.get_change_info;
      }

      var itemId = row.itemId;
      var itemClassId = row.itemClassId;
      var itemSubClassId = row.itemSubClassId;

      var obj_get = {
        //获取change
        id: itemId,
        classId: itemClassId,
        subClassId: itemSubClassId,
        changeId: change_info.changeId,
        changeClassId: change_info.changeClassId,
        changeSubClassId: change_info.changeSubClassId,
        tableId: 4,
      };

      var loadTableUrl = `/pmdm/items/loadTable${this.params(obj_get)}`;

      const {
        //获取标题测试 第3页
        data: res,
      } = await this.$http.get(loadTableUrl);

      var table_content_text = this.getNewTableContentData(res);
      for (var i in table_content_text) {
        //添加不可编辑
        this.childsTable.push(table_content_text[i]);
      }
      return table_content_text;
    },
    loadUserPriv() {
      var priv_ = this.getUserContextPriv();

      let subClass_Id = this.$store.state.objectId.subClassId;

      for (let i = 0; i < priv_.length; i++) {
        if (priv_[i].classId == subClass_Id) {
          if (priv_[i].type == 4) {
            this.removeBtnPriv = true;
          }
          if (priv_[i].type == 3) {
            this.addTableListPriv = true;
          }
        }
      }

      let isSupAdmin = this.$store.state.isSuperAdmin;
      if (isSupAdmin) {
        this.removeBtnPriv = true;
        this.exportBtnPriv = true;
        this.addTableListPriv = true;
      }
    },
  },
  created() {
    const { changeInfoNum = "[{}]" } = this.$route.query;
    const arr = JSON.parse(changeInfoNum);
    this.editTable = arr.length == 1;
    this.getBomInfo();
    this.loadUserPriv();
    setTimeout(() => {
      this.loading = false;
    }, 500);
  },
  props: ["changeValue"],
  watch: {
    changeValue: function (value) {
      this.get_change_info = value;

      this.getBomInfo();
    },
  },
};
</script>

<style>
.searchAddBomList .el-dialog__body {
  padding: 0 20px 20px 20px !important;
}

.el-table th.gutter {
  display: table-cell !important;
}

.link_ {
  color: #4b92ff;
  cursor: pointer;
}

.link_:hover {
  color: #4b92ff;
  cursor: pointer;
  border-bottom: 1px solid #4b92ff;
}
</style>
